/* mw-cart: Cart AJAX API + re-render do drawer via Section Rendering.
   Fallback sem JS: forms POST /cart/add e pagina /cart (rule performance-a11y).

   Arquivo do CORE (carrega em toda pagina; teto somado em scripts/check-js-budget.mjs). Por isso os
   literais que se repetem viram const la em cima: selecionador, URL de rota e
   objeto de headers escritos duas vezes custam bytes de todo mundo, inclusive de
   quem so abriu a home. A regra e simples: repetiu, hoista. */
(function () {
  'use strict';
  var doc = document;
  var qs = function (s, r) { return (r || doc).querySelector(s); };
  /* NodeList estatica direto do querySelectorAll: todo uso aqui e .forEach, que
     a NodeList tem nativamente. O Array.prototype.slice.call que existia aqui so
     pagava por um Array que ninguem usava como Array. */
  var qsa = function (s, r) { return (r || doc).querySelectorAll(s); };
  var rj = function (r) { return r.json(); };
  var JSN = { 'Content-Type': 'application/json', Accept: 'application/json' };
  var U_CART = '/cart.js';
  var U_ADD = '/cart/add.js';
  var U_UPD = '/cart/update.js';
  var S_NOTE = '[data-mw-note]';
  var S_CHK = '[data-mw-presente-chk]';
  var S_CONT = '[data-mw-cart-conteudo]';
  var S_ROL = '.mw-cart-rolagem';
  var S_LINHA = '[data-key]';
  /* ganchos dos tres botoes de linha: [0] mais, [1] menos, [2] remover */
  var PASSOS = ['data-mw-line-mais', 'data-mw-line-menos', 'data-mw-line-remover'];
  var SEL_PASSO = '[' + PASSOS.join('],[') + ']';
  var ultimoCart = null;

  /* Frete lembrado do drawer: mostra a ultima cotacao feita na /cart, e SO
     quando ela ainda vale. mw-compra.js (template cart) grava o snapshot
     mw_compra_frete = { cep, opcao, resultado: { nome, valorCentavos,
     prazoDiasUteis: [min, max] }, pesoGramas, subtotalCentavos, ts }; o cep vai
     ja formatado. Peso e subtotal do snapshot batendo com os do carrinho de
     agora = a cotacao continua verdadeira. Nao batendo (mexeu na quantidade,
     trocou de rotulo) ou sem snapshot, cai no link de calcular - melhor nada do
     que um frete errado. As strings vem em data-* porque o core nao tem i18n.

     O `ts` era GRAVADO e nunca lido: um snapshot de dias atras seguia valendo
     enquanto peso e subtotal nao mudassem, e o drawer mostrava o preco de uma
     tabela que podia ja ter sido trocada. TTL de 10 minutos (TTL_FRETE),
     casado com o `max-age=600` da resposta de /apps/curador/frete e com a
     janela da ordem segura de virada de tabela (plano do frete, T1). Vencido
     ou sem `ts` (NaN na conta, que reprova) = mesmo caminho de peso divergente:
     o CTA de calcular. */
  var TTL_FRETE = 6e5;
  function slot(raiz, nome, txt) {
    var el = qs('[data-mw-frete-' + nome + ']', raiz);
    if (el) el.textContent = txt;
  }

  function hidratarFrete() {
    var caixa = qs('[data-mw-frete-lembrado]');
    if (!caixa) return;
    var ok = qs('[data-mw-frete-ok]', caixa);
    var nao = qs('[data-mw-frete-nao]', caixa);
    var snap = null;
    try { snap = JSON.parse(localStorage.getItem('mw_compra_frete')); } catch (e) { /* bloqueado ou lixo */ }
    var r = snap && snap.resultado;
    var vale = !!(r && r.prazoDiasUteis && snap.cep && ultimoCart
      && Date.now() - snap.ts < TTL_FRETE
      && snap.pesoGramas === ultimoCart.total_weight
      && snap.subtotalCentavos === ultimoCart.items_subtotal_price);
    if (vale && ok) {
      slot(ok, 'cep', snap.cep);
      slot(ok, 'valor', r.valorCentavos === 0
        ? caixa.getAttribute('data-gratis')
        : 'R$ ' + (r.valorCentavos / 100).toFixed(2).replace('.', ','));
      slot(ok, 'prazo', caixa.getAttribute('data-prazo-tpl')
        .replace('{{ a }}', r.prazoDiasUteis[0])
        .replace('{{ b }}', r.prazoDiasUteis[1]));
    }
    if (ok) ok.toggleAttribute('hidden', !vale);
    if (nao) nao.toggleAttribute('hidden', vale);
  }

  /* A contagem na tela: a do Liquid ate o primeiro /cart.js, depois a de cada
     carrinho lido e, no 200 de um add, a otimista (somar, abaixo). */
  var conta = +(qs('[data-mw-cart-count]') || {}).textContent || 0;
  function contar(c) {
    var mudou = c !== conta;
    conta = c;
    qsa('[data-mw-cart-count]').forEach(function (el) {
      el.textContent = String(c).padStart(2, '0');
    });
    qsa('[data-mw-cart-dot]').forEach(function (el) {
      el.toggleAttribute('hidden', !c);
      /* reinicia a animacao mwpop, so quando o numero muda: a reconciliacao que
         confirma o numero otimista nao pulsa de novo */
      if (mudou) {
        el.style.animation = 'none';
        void el.offsetWidth;
        el.style.animation = '';
      }
    });
    /* nome acessivel do acesso ao carrinho com a contagem (P14d): data-t0 com o
       carrinho vazio, data-t1 com uma garrafa, data-t2 com mais (%c = contagem) */
    qsa('[data-mw-cart-nome]').forEach(function (el) {
      var t = el.getAttribute('data-t' + (c > 1 ? 2 : c ? 1 : 0));
      if (t) el.setAttribute('aria-label', t.split('%c').join(c));
    });
    /* o "Ver carrinho (N)" do aviso acompanha o contador */
    var v = aviso && aviso.getAttribute('data-t-ver');
    if (v) av('compra').textContent = v.split('%n').join(c);
  }

  /* marca "No carrinho ✓" nos cards dos handles de `itens`; `todos` (carrinho
     inteiro) tambem desmarca os outros. Linha de EVENTO (_mw_ev) nao marca o
     card: com "No carrinho ✓" o toque abre o carrinho, e o presente do evento
     impediria o cliente de comprar uma garrafa para si (mesma regra do Liquid
     em snippets/card-produto.liquid) */
  function naSacola(itens, todos) {
    var h = {};
    itens.forEach(function (i) { if (!(i.properties || {})._mw_ev) h[i.handle] = 1; });
    qsa('[data-mw-card][data-handle]').forEach(function (card) {
      var s = !!h[card.getAttribute('data-handle')];
      if (s || todos) card.toggleAttribute('data-mw-na-sacola', s);
    });
  }

  /* P14a: no 200 do add a tela muda JUNTA e na hora: contador (o de agora + o
     que entrou) e "No carrinho ✓" nos cards das linhas que o add.js devolveu.
     Nada espera a segunda ida: o GET /cart.js que vem atras so reconcilia. */
  function somar(j, q) {
    contar(conta + q);
    naSacola(j.items || []);
  }

  /* A LIMPEZA do carrinho lido: um POST so, e so quando ha o que limpar, porque
     este caminho roda em toda pagina, a cada carrinho lido. keepalive porque, na
     /cart, o esvaziar recarrega a pagina logo depois do mw:cart.
     - Carrinho vazio nao guarda presente de ninguem (achado M2 da rodada do
       frete de 2026-09-29): a escolha, o nome, o email de quem recebe e o recado
       de um carrinho abandonado seguiam para o proximo pedido, montado para outra
       pessoa, e a gaveta nao mostra nenhum deles.
     - Carrinho com presente de EVENTO (linha com _mw_ev) e a caixa "Este pedido
       e um presente" marcada, ou uma pessoa ou email de quem recebe guardados
       (R32 da frente eventos, decisao 135 do dono, "Dizer no vinho, recado por
       pessoa"; plano EVENTOS-2026-10-R32, 9.9 item 4): a caixa some do carrinho
       de evento, entao a marca que veio de antes (a caixa marcada para a mae,
       antes de o presente de evento entrar) sai com a pessoa, o email e o
       recado; sem isso o pedido sairia como presente sem o cliente ver. Basta a
       pessoa sem a marca: o sync liga o pedido pelo presenteado_id sem olhar a
       marca, e o Finalizar da gaveta nao leva os vazios da /cart (revisao da
       frete, 15/10). Com algo que a pessoa escreveu ou escolheu para o presente
       comum (o recado, a pessoa ou o email), o vinho do evento nem entra: a
       trava do addVariant (abaixo; D7, plano R32 9.13, "Impedir no Adicionar")
       recusa o add antes do POST, e nada e apagado. Esta limpeza fica como rede
       calada, sem aviso, para o que passa pela trava: a marca sozinha, que nao
       perde nada; a leitura do carrinho que falhou na hora do add; e outra aba
       que marca o presente comum depois de o vinho do evento entrar.
     - O recado do presente de evento, um atributo por pessoa
       (recado_evento_<chave>, com a chave da propriedade _mw_para da linha): sai
       o de quem nao tem mais linha no carrinho (no vazio, todos), e a gravacao
       pendente dele morre junto (`pend`, ver o recado mais abaixo).
     _mw_ev e _mw_para sao chaves de CONTRATO com o painel
     (painel/src/lib/eventos/presente-para.ts). */
  var PII = ['presente', 'presenteado_id', 'presenteado_nome', 'presenteado_email'];
  var REC = 'recado_evento_';
  var pend = {};
  function limpar(cart) {
    var a = cart.attributes || {}, corpo = { attributes: {} }, sujo = 0, tem = {}, ev = 0, k;
    (cart.items || []).forEach(function (i) {
      var p = i.properties || {};
      if (p._mw_ev) ev = 1;
      if (p._mw_para) tem[REC + p._mw_para] = 1;
    });
    if (!cart.item_count || ev && PII.some(function (k) { return a[k]; })) {
      guarda = null;
      clearTimeout(t);
      corpo.note = '';
      if (cart.note) sujo = 1;
      PII.forEach(function (k) { if (a[k]) sujo = 1; corpo.attributes[k] = ''; });
    }
    for (k in pend) if (!tem[k]) { clearTimeout(pend[k]); delete pend[k]; }
    /* so o que tem valor: a chave guardada vazia nao pede POST a cada leitura */
    for (k in a) if (a[k] && !k.indexOf(REC) && !tem[k]) { corpo.attributes[k] = ''; sujo = 1; }
    if (sujo) fetch(U_UPD, { method: 'POST', headers: JSN, body: JSON.stringify(corpo), keepalive: true }).catch(nada);
  }

  function atualizarHeader(cart) {
    ultimoCart = cart;
    limpar(cart);
    contar(cart.item_count);
    naSacola(cart.items || [], 1);
    doc.dispatchEvent(new CustomEvent('mw:cart', { detail: cart }));
    hidratarFrete();
  }

  /* depois do 200 de um add: o redesenho que veio no proprio POST (h) entra ja;
     sem ele, sai por GET (a promessa devolvida acompanha esse GET). O GET
     /cart.js corre atras e so reconcilia; falha dele nunca vira aviso de erro,
     porque o add ja entrou. */
  function acertar(h) {
    fetch(U_CART).then(rj).then(atualizarHeader).catch(nada);
    if (!h) return reRenderDrawer();
    trocar(h);
    return Promise.resolve();
  }
  function nada() {}

  function reRenderDrawer() {
    return fetch(window.location.pathname + '?sections=cart-drawer')
      .then(rj)
      .then(function (secoes) { trocar(secoes['cart-drawer']); });
  }

  /* troca o miolo do drawer pelo HTML da section. Vem do GET acima ou, no
     adicionar, do proprio POST /cart/add.js (sections=cart-drawer). */
  function trocar(htmlNovo) {
    /* clique novo entrou durante o fetch: este HTML ja nasceu velho e
       apagaria a pintura otimista. Quem re-renderiza e o commit do POST que
       esta em voo. */
    if (!htmlNovo || voando) return;
    var tmp = doc.createElement('div');
    tmp.innerHTML = htmlNovo;
    var novo = qs(S_CONT, tmp);
    var atual = qs(S_CONT);
    if (novo && atual) {
      /* O swap troca o checkbox de presente por HTML do servidor, que pode
         estar atras do POST da escolha: sem guardar o que esta na tela, o valor
         velho volta. (A caixa de texto do recado saiu do drawer em 2026-09-29:
         o recado mora so na /cart, fora do que este swap troca.) */
      var chk = qs(S_CHK, atual);
      var marcado = chk ? chk.checked : null;
      /* O stepper agora e clicavel em rajada: sem guardar o scroll a lista
         volta ao topo a cada swap, e sem guardar a IDENTIDADE do foco (tipo
         de botao + key da linha) o teclado cai no body. Identidade, nunca
         posicao: linha removida embaralha indice. */
      var rol = qs(S_ROL, atual);
      var altura = rol ? rol.scrollTop : 0;
      var ativo = doc.activeElement;
      /* so o foco que estava DENTRO do drawer volta: na /cart a mesma key
         existe nas duas listas, e um botao da pagina "voltaria" pro drawer */
      var passo = ativo && atual.contains(ativo) && ativo.closest(SEL_PASSO);
      var linha = passo && passo.closest(S_LINHA);
      var chave = linha && linha.getAttribute('data-key');
      var refoco = null;
      for (var i = 0; chave && i < 3; i++) {
        if (passo.hasAttribute(PASSOS[i])) refoco = '[data-key="' + chave + '"] [' + PASSOS[i] + ']';
      }
      atual.innerHTML = novo.innerHTML;
      chk = qs(S_CHK, atual);
      if (chk && marcado != null) chk.checked = marcado;
      rol = qs(S_ROL, atual);
      if (rol) rol.scrollTop = altura;
      if (refoco) {
        var volta = qs(refoco, atual);
        if (volta) volta.focus();
      }
      selo();
    }
    /* o re-render acontece DEPOIS do mw:cart e devolve o frete lembrado ao
       estado neutro do servidor; re-hidratar aqui e o que o faz sobreviver */
    hidratarFrete();
  }

  function sincronizar(abrirDrawer) {
    return fetch(U_CART)
      .then(rj)
      .then(function (cart) {
        atualizarHeader(cart);
        return reRenderDrawer().then(function () {
          if (abrirDrawer && window.MW) window.MW.abrir('cart');
        });
      });
  }

  /* ---------- aviso do "adicionado" (P7 de 2026-09-25; completo no P14a) ----------
     Markup e ciclo de vida em snippets/carrinho-aviso.liquid. tipo: 'ok'
     (adicionou: miniatura, nome, preco e "Ver carrinho (N)"), 'fim' (422 e a
     variante ja esta no carrinho: todo o estoque esta la), 'esg' (422 e ela nao
     esta: esgotou agora; o CTA vira o avise-me), 'erro' (rede ou servidor) e
     'outro' (a trava do D7 no addVariant: o carrinho ja tem um presente comum
     com recado, pessoa ou email; o losango do erro e o "Ver carrinho", porque e
     no carrinho que a pessoa finaliza esse pedido).
     `d` = { nome, url, preco, img }: os data-* do form ou o proprio card do
     Curador, que tem os mesmos campos. Com o Curador aberto o no vai para o
     espaco dele (slot visivel = offsetParent) e fica no fluxo; senao volta para a
     casa e fica fixo no pe da tela, com html.mw-aviso-on. A regiao de status e
     esvaziada e preenchida depois de um tique: e o que faz o leitor de tela
     anunciar, tambem quando o texto se repete. */
  var html = doc.documentElement;
  /* [data-t-fim] porque so o aviso do snippet carrinho-aviso tem os textos: na pagina
     /cart o paragrafo de presente do main-cart.liquid tambem e [data-mw-aviso] e vem
     antes no HTML (achado da frente eventos em 2026-10-01). */
  var aviso = qs('[data-mw-aviso][data-t-fim]');
  var casa = aviso && aviso.parentNode;
  var origem = null; /* botao do ultimo adicionar da pagina: para onde o foco volta */
  function av(n) { return qs('[data-mw-aviso-' + n + ']', aviso); }
  function naPagina() { return html.classList.contains('mw-aviso-on'); }

  function avisar(tipo, d) {
    if (!aviso) return;
    d = d || {};
    var slot = qs('[data-mw-aviso-slot]');
    var dentro = !!(slot && slot.offsetParent);
    (dentro ? slot : casa).appendChild(aviso);
    var ok = tipo === 'ok';
    var nome = d.nome || '';
    /* sem o data-t- do tipo (o snippet de antes, numa publicacao em partes, nao
       tem o data-t-outro), vale o texto do erro: nunca excecao nem barra vazia */
    var txt = ok ? nome : (aviso.getAttribute('data-t-' + tipo) || aviso.getAttribute('data-t-erro') || '').split('%n').join(nome);
    var barra = av('barra');
    var st = av('status');
    var a = av('avise');
    /* sem o "Ver carrinho": o estoque e a rede; o 'outro' tem o losango E o botao */
    var falhou = tipo === 'esg' || tipo === 'erro';
    var img = ok && d.img;
    av('txt').textContent = txt;
    av('preco').textContent = ok && d.preco || '';
    av('thumb').hidden = !img;
    if (img) av('img').src = img;
    barra.toggleAttribute('data-ok', ok);
    barra.toggleAttribute('data-erro', falhou || tipo === 'outro');
    av('compra').hidden = falhou;
    a.hidden = tipo !== 'esg';
    if (d.url) a.href = d.url + '#avise';
    barra.hidden = false;
    html.classList.toggle('mw-aviso-on', !dentro);
    html.style.setProperty('--mw-aviso-h', barra.offsetHeight + 'px');
    /* no ok o status diz tambem a contagem: %n = nome, %c = contagem */
    if (ok) txt = aviso.getAttribute('data-t-st' + (conta > 1 ? 2 : 1)).split('%n').join(nome).split('%c').join(conta);
    st.textContent = '';
    setTimeout(function () { st.textContent = txt; }, 100);
  }

  /* P14b: a linha que acabou de entrar pela pagina do vinho ganha o selo (CSS
     em sections/cart-drawer.liquid, [data-mw-novo]) enquanto o carrinho esta
     aberto por aquele add. `recem` e o seletor da linha; o redesenho do carrinho
     (trocar) o repoe, e qualquer drawer que abre depois o zera. Fechado, o
     carrinho some com o selo junto. */
  var recem = null;
  function selo() {
    var cont = qs(S_CONT);
    if (!cont) return;
    qsa('[data-mw-novo]', cont).forEach(function (l) { l.removeAttribute('data-mw-novo'); });
    var l = recem && qs(recem, cont);
    if (l) l.setAttribute('data-mw-novo', '');
  }

  function fecharAviso() {
    if (!aviso) return;
    av('barra').hidden = true;
    av('status').textContent = '';
    html.classList.remove('mw-aviso-on');
  }

  /* fechar pelo x ou pelo Esc: o foco que estava na barra volta ao botao que
     adicionou (na pagina) ou a conversa (no Curador), nunca cai no body */
  function fecharPeloCliente() {
    var volta = aviso.contains(doc.activeElement) && (naPagina() ? origem : qs('[data-mw-chat]'));
    fecharAviso();
    if (volta && volta.isConnected) volta.focus({ preventScroll: true });
  }

  /* add recusado: `r` e a Response (ou o erro de rede), ou a recusa da trava do
     addVariant ({ mw: 'outro' }, D7), que ja diz o tipo do aviso. No 422 a
     Shopify pode ter posto so o que havia (doc da Cart API), entao quem decide a
     mensagem e o carrinho de verdade, relido aqui. */
  function falha(r, vid, d) {
    if (r && r.mw) return avisar(r.mw, d);
    if (!r || r.status !== 422) return avisar('erro', d);
    return fetch(U_CART).then(rj).then(function (c) {
      atualizarHeader(c);
      avisar(c.items.some(function (i) { return i.variant_id == vid; }) ? 'fim' : 'esg', d);
      reRenderDrawer().catch(nada);
    }, function () { avisar('erro', d); });
  }

  /* abrir carrinho, menu ou Curador fecha a barra e tira o selo (P14b) */
  doc.addEventListener('mw:drawer', function (e) {
    if (e.detail && e.detail.aberto) {
      fecharAviso();
      recem = null;
      selo();
    }
  });

  if (aviso) {
    /* captura: roda antes do clique delegado do mw-core */
    doc.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-mw-aviso-x]')) fecharPeloCliente();
      /* "Ver carrinho" na pagina: o foco passa ao botao de origem ANTES de o
         mw-core guardar quem abriu o carrinho, e e para ele que o foco volta
         quando o carrinho fecha (o botao da barra some junto com ela) */
      else if (t.closest('[data-mw-aviso-compra]') && naPagina() && origem && origem.isConnected) origem.focus({ preventScroll: true });
      /* "Me avisa" na propria PDP: o #avise so existe na pagina do esgotado, e
         um link so de ancora nao recarrega. Recarrega na ancora. */
      else if ((t = t.closest('[data-mw-aviso-avise]')) && t.pathname === location.pathname) {
        e.preventDefault();
        location.hash = 'avise';
        location.reload();
      }
    }, true);
    doc.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !av('barra').hidden) fecharPeloCliente();
    });
  }

  /* adicionar via form de produto/card. Card: no 200 do add.js o aviso, o
     "No carrinho ✓" do card e o contador mudam JUNTOS (P14a), e o GET /cart.js
     que vem atras so reconcilia. PDP (data-mw-add="abrir"): o 200 abre o
     carrinho lateral ja redesenhado, com o selo na linha que entrou (P14b); o
     aviso so atende o 422 e o erro la.
     - aria-disabled + form.voando no lugar de disabled: o foco fica no botao
       (disabled o jogava no body) e o toque repetido durante o POST nao soma
       outra garrafa. O aria-disabled tambem troca o texto do botao por
       "Adicionando..." (CSS do card e da PDP), e sai no 200: dali em diante o
       card ja diz "No carrinho ✓", cujo toque so abre o carrinho.
     - sections=cart-drawer no proprio POST (Section Rendering junto, doc da Cart
       API): o redesenho vem na resposta e corta uma viagem. Sem ele na resposta,
       cai no GET de sempre.
     - SEM form.submit() de fallback: ele reenviava o POST quando o add ja tinha
       dado certo e so a sincronizacao falhava (garrafa duplicada), e num 422
       tirava o cliente da pagina. Falha agora e aviso na barra.
     - Card ja em "No carrinho ✓": o toque abre o carrinho lateral.
     - O corpo vai no formato items[] (FORMATO_ITEMS abaixo), o unico em que a
       Shopify confere o estoque no add. */
  doc.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-mw-add]');
    if (!form) return;
    e.preventDefault();
    var botao = qs('[type="submit"]', form);
    if (form.closest('[data-mw-na-sacola]')) {
      if (window.MW) window.MW.abrir('cart', botao);
      return;
    }
    if (form.voando) return;
    form.voando = 1;
    origem = botao;
    if (botao) botao.setAttribute('aria-disabled', 'true');
    var pdp = form.getAttribute('data-mw-add') === 'abrir';
    /* nome, url, preco (ja formatado pelo Liquid) e miniatura do aviso */
    var g = function (a) { return form.getAttribute('data-' + a); };
    var d = { nome: g('nome'), url: g('url'), preco: g('preco'), img: g('img') };
    var qtd = qs('input[name="quantity"]', form);
    /* os forms de card e PDP so levam id e quantity */
    var item = { id: +qs('input[name="id"]', form).value, quantity: qtd ? +qtd.value || 1 : 1 };
    fetch(U_ADD, { method: 'POST', headers: JSN, body: JSON.stringify({ items: [item], sections: 'cart-drawer' }) })
      .then(function (r) {
        if (!r.ok) return falha(r, item.id, d);
        if (qtd) qtd.value = 1;
        /* daqui em diante o add JA entrou: falha na sincronizacao so deixa o
           numero do cabecalho para o proximo evento, nunca reenvia nada */
        return rj(r).catch(nada).then(function (j) {
          j = j || {};
          var i0 = (j.items || [])[0];
          solta();
          somar(j, item.quantity);
          if (!pdp) avisar('ok', d);
          acertar(j.sections && j.sections['cart-drawer']).then(function () {
            if (!pdp || !window.MW) return;
            window.MW.abrir('cart', botao);
            recem = i0 ? '[data-key="' + i0.key + '"]' : '[data-vid="' + item.id + '"]';
            selo();
          }, function () {
            if (pdp) avisar('ok', d);
          });
          /* nada daqui para cima chega ao aviso de erro do catch de baixo: o add
             ja entrou, e "tente de novo" somaria outra garrafa */
        }).catch(nada);
      })
      .catch(function () { avisar('erro', d); })
      .then(solta, solta);
    function solta() {
      form.voando = 0;
      if (botao) botao.removeAttribute('aria-disabled');
    }
  });

  /* FORMATO_ITEMS. O /cart/add.js so confere o estoque quando o corpo vem no
     formato items[] (JSON { items: [...] } ou form items[][id]). No formato solto
     (id + quantity, em form OU em JSON) ele aceita passar do estoque: medido em
     2026-09-25 (lancamento, P7) com o Calamares, 1 garrafa com politica deny,
     duas vezes quantity=1 = 200 e 200 com 2 no carrinho, e quantity=2 de uma vez
     = 200; no formato items[] o segundo add volta 422 "Seu carrinho ja tem a
     quantidade maxima deste item.". O change.js confere nos dois. Ate esta data
     o tema mandava o formato solto e o cliente so descobria no checkout. Todo
     add do tema usa items[]; nunca voltar ao solto. */

  /* adicionar por id de variante (cards do Curador, conta, evento); props = line
     item properties (ex.: { _curador: '1' } - oculta no drawer/carrinho pela
     convencao do underscore). Contrato: resolve so depois do 200, com o JSON do
     add.js ({ items: [...] }, as linhas que entraram), e rejeita com a Response
     (ou o erro de rede) quando o add nao entrou, ou com { mw: 'outro' } quando a
     trava abaixo o recusou sem POST (o falha() mostra cada um).
     A TRAVA DO PRESENTE DE EVENTO (D7, plano R32 9.13, "Impedir no Adicionar",
     decisao do dono de 29/10): a linha com o claim _mw_ev nao entra num
     carrinho que ja tem algo que a pessoa escreveu ou escolheu para um presente
     comum (a nota, que e o recado, ou a pessoa ou o email de quem recebe). Um
     pedido vai para um endereco so, o pedido de evento nunca manda email a quem
     recebe (decisao 97), e entrar faria a limpeza apagar esse presente. Fica no
     nucleo, e nao no embrulho da pagina do evento: o card do Curador chama o
     addVariant direto em qualquer pagina, com o claim nos props, e os cards
     valem 24 h. O carrinho e relido na hora (o ultimoCart pode ser de antes de
     outra aba marcar o presente). A marca `presente` sozinha nao barra (nada se
     perde, e a limpeza a tira calada), e a leitura que falha deixa o add seguir,
     com a limpeza como rede. */
  window.MWCart = {
    addVariant: function (vid, props) {
      var item = { id: vid, quantity: 1 };
      if (props) item.properties = props;
      return (props && props._mw_ev ? fetch(U_CART).then(rj).then(function (c) {
        var a = c.attributes || {};
        return (c.note || '').trim() || QUEM.some(function (k) { return a[k]; }) || naTela();
      }).catch(nada) : Promise.resolve()).then(function (barra) {
        if (barra) throw { mw: 'outro' };
        return fetch(U_ADD, {
          method: 'POST',
          headers: JSN,
          body: JSON.stringify({ items: [item] })
        });
      }).then(function (r) {
        if (!r.ok) throw r;
        /* o add JA entrou: resolve AGORA, com o contador e os cards otimistas
           (P14a), e a sincronizacao (GET /cart.js + redesenho) corre atras sem
           segurar quem chamou. Falha so nela nunca vira rejeicao: rejeitar fazia
           o card do Curador (e a conta) dizer "tente de novo" com a garrafa no
           carrinho, e a nova tentativa somava outra. Mesma regra do submit. */
        return rj(r).catch(nada).then(function (j) {
          j = j || {};
          try { somar(j, 1); } catch (e) { /* a tela acerta no GET que vem atras */ }
          acertar().catch(nada);
          return j;
        });
      });
    },
    sincronizar: sincronizar,
    /* mw-compra.js (input de quantidade da /cart) entra pelo mesmo motor */
    mudar: mudar,
    /* aviso do "adicionado" para o card do Curador (mw-curador.js): avisar(tipo,
       d) e falha(r, vid, d), com d = o card ({ nome, url, preco, img }). Fora
       do addVariant de proposito: a conta ("repetir") e o evento tem aviso
       proprio e passam pelo addVariant. */
    avisar: avisar,
    falha: falha
  };

  /* Stepper otimista (Baymard; Hydrogen useOptimisticCart). O clique pinta a
     quantidade AGORA e o POST corre atras - antes eram 3 viagens em serie e a
     linha so mudava no swap final, o que parecia botao quebrado.
     `alvos` guarda a quantidade DESEJADA por item.key e bombear() manda um POST
     por vez: clique novo durante o voo so troca o alvo, e o ultimo vence. Nada de
     `disabled` nos botoes - cliques em rajada coalescem no alvo em vez de serem
     engolidos.
     A resposta do /cart/change.js JA e o carrinho inteiro, entao este caminho
     nao tem mais o GET /cart.js (o add continua em sincronizar).
     Falha (rede ou !ok) = zera os alvos e re-renderiza do servidor: a tela volta
     ao que o carrinho realmente tem, e o aria-live do conteudo anuncia. */
  var alvos = {};
  var voando = false;

  function mudar(key, qty) {
    qty = qty > 0 ? qty : 0;
    alvos[key] = qty;
    /* na /cart o drawer e a pagina renderizam a MESMA key: as duas copias pintam
       juntas, sem espelho proprio. data-qty vive na LINHA (nao nos botoes): a
       quantidade e da linha, e assim uma escrita basta. */
    qsa('[data-key="' + key + '"]').forEach(function (linha) {
      linha.setAttribute('data-qty', qty);
      var d = qs('[data-mw-line-qtd]', linha);
      if (d) { if ('value' in d) d.value = qty; else d.textContent = qty; }
      linha.setAttribute('data-mw-pend', '');
      linha.hidden = !qty;
    });
    bombear();
  }

  function bombear(cart) {
    if (voando) return;
    var key = null;
    for (var k in alvos) { key = k; break; }
    if (!key) {
      /* fila vazia: o carrinho da ultima resposta e a verdade */
      if (cart) { atualizarHeader(cart); reRenderDrawer(); }
      return;
    }
    var qty = alvos[key];
    delete alvos[key];
    voando = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: JSN,
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) {
        if (!r.ok) throw r;
        return rj(r);
      })
      .then(function (c) { voando = false; bombear(c); })
      .catch(function () { voando = false; alvos = {}; sincronizar(false); });
  }

  doc.addEventListener('click', function (e) {
    var b = e.target.closest(SEL_PASSO);
    if (!b) return;
    e.preventDefault();
    var linha = b.closest(S_LINHA);
    if (!linha) return;
    var q = +linha.getAttribute('data-qty') || 1;
    var mais = b.hasAttribute(PASSOS[0]);
    /* teto de estoque da linha (data-max, sections/cart-drawer.liquid): o + para
       nele. Linha sem data-max (sem controle de estoque, ou a copia da pagina
       /cart, cujo teto fica para depois) nao tem teto. */
    var teto = linha.getAttribute('data-max');
    if (mais && teto && q >= +teto) return;
    mudar(
      linha.getAttribute('data-key'),
      b.hasAttribute(PASSOS[2]) /* remover */ ? 0 : q + (mais ? 1 : -1)
    );
  });

  /* Na /cart o drawer e a pagina convivem, cada um com sua copia do checkbox. O
     servidor e um so: o que o usuario mexe numa copia vale na outra na hora
     (senao o re-render do drawer devolve o valor velho por cima). */
  function espelhar(sel, origem, aplicar) {
    qsa(sel).forEach(function (el) { if (el !== origem) aplicar(el); });
  }

  /* recado de presente -> cart note (debounce). A caixa de texto so existe na
     /cart desde 2026-09-29 (saiu do drawer): uma copia so, sem espelho. Fica no
     core porque o desmarcar abaixo, que tambem roda no drawer, mata o debounce
     pendente (t) antes de zerar a note. */
  var t;
  doc.addEventListener('input', function (e) {
    var el = e.target, n = el.getAttribute('data-mw-rec'), valor = el.value;
    if (n) {
      clearTimeout(pend[n]);
      pend[n] = setTimeout(function () { gravarRec(n, valor); }, 600);
      return;
    }
    if (!el.matches(S_NOTE)) return;
    clearTimeout(t);
    t = setTimeout(function () {
      fetch(U_UPD, {
        method: 'POST',
        headers: JSN,
        body: JSON.stringify({ note: valor })
      });
    }, 600);
  });

  /* O RECADO DO PRESENTE DE EVENTO -> atributo recado_evento_<chave> do
     carrinho (R32 da frente eventos, decisao 135; plano 9.9 item 2): um campo
     por pessoa, so na /cart (sections/main-cart.liquid; data-mw-rec = o nome do
     atributo). Grava na saida do campo e, digitando, com a mesma espera da nota
     (input acima); sem JS, o form nativo leva o atributo no Finalizar. Fica no
     nucleo, ao lado da nota, porque a limpeza (limpar, acima) mata a gravacao
     pendente do recado de quem saiu do carrinho: sem isso ela regravaria o
     atributo logo depois de ele sair. keepalive: a gravacao da saida do campo
     sobrevive a um Finalizar ou a uma navegacao logo em seguida. */
  function gravarRec(n, v) {
    var a = {};
    clearTimeout(pend[n]);
    delete pend[n];
    a[n] = v;
    fetch(U_UPD, { method: 'POST', headers: JSN, body: JSON.stringify({ attributes: a }), keepalive: true }).catch(nada);
  }
  doc.addEventListener('focusout', function (e) {
    var el = e.target, n = el.getAttribute && el.getAttribute('data-mw-rec');
    if (n && pend[n]) gravarRec(n, el.value);
  });

  /* "este pedido e um presente" -> cart attributes. A visibilidade do recado e
     CSS (:checked), nao daqui; este handler so persiste a escolha para o drawer,
     a /cart e o checkout concordarem. Sem JS, o mesmo checkbox viaja no POST
     /cart do form da /cart (o do drawer nao tem name de proposito). Nao
     re-renderiza o drawer: nada no HTML depende do valor alem do proprio
     checked, que o usuario acabou de mudar. */
  var espelhando = false;
  /* Fora da /cart nao ha caixa de texto do recado, campo de email nem chips de
     pessoa (moram so la desde 2026-09-29): desmarcar aqui guarda o recado e os
     tres atributos de quem recebe (id, nome e email), e remarcar nesta mesma
     pagina os repoe - senao o recado escrito na /cart sumia num desmarca-e-marca
     da gaveta, sem nada na tela (achado MB1). O id e o nome voltam junto com o
     email: sem eles, a /cart abria sem pessoa escolhida (st.sel e emDe nulos no
     mw-compra.js), e o chip de outra pessoa sem email ficava com o email da
     primeira, que receberia o recado com o nome da segunda. So guarda valor que
     existe: um carrinho ainda nao relido depois de outro desmarcar nao apaga o
     guardado. O carrinho que esvazia o joga fora (limpar). "Fora da /cart" e a
     pagina sem a section do carrinho ([data-mw-compra]), e nao a falta da caixa de
     texto: no carrinho de evento de antes da R32 a /cart nao tinha o recado, mas
     tinha os chips, e o mw-compra.js acabava de zerar a escolha na tela - repor o
     id no servidor ali deixaria o pedido ligado a quem a tela nao mostra. */
  var guarda = null;
  var QUEM = PII.slice(1);
  /* A trava do D7 olha tambem a TELA da /cart: o nome que o visitante digitou so
     viaja no submit, e o recado e o email esperam a espera ou o change. Com a
     pergunta visivel e marcada e algo escrito, o add do evento tambem para. */
  function naTela() {
    var pa = qs('[data-mw-compra] [data-mw-cart-pergunta]'), chk = pa && qs(S_CHK, pa), v = false;
    if (!chk || !chk.checked || pa.hidden) return false;
    qsa('#mw-nome-recebe,' + S_NOTE + ',[data-mw-em]', pa).forEach(function (i) { if ((i.value || '').trim()) v = true; });
    return v;
  }
  doc.addEventListener('change', function (e) {
    if (espelhando || !e.target.matches(S_CHK)) return;
    var on = e.target.checked;
    /* O espelho dispara change nas copias: na /cart quem escuta a copia da pagina
       e o mw-compra.js, que precisa limpar os hidden de presenteado quando o
       cliente desmarca pelo drawer. A flag impede que o evento sintetico volte a
       cair aqui e faca outro POST. */
    espelhando = true;
    espelhar(S_CHK, e.target, function (el) {
      el.checked = on;
      el.dispatchEvent(new Event('change', { bubbles: true }));
    });
    espelhando = false;
    var corpo = { attributes: { presente: on ? 'sim' : '' } };
    var ta = qs(S_NOTE);
    if (on) {
      /* remarcou na /cart: o recado que ficou na tela volta a valer no servidor;
         fora dela, volta o que o desmarcar guardou */
      if (ta) { if (ta.value) corpo.note = ta.value; }
      else if (guarda) {
        corpo.note = guarda.note;
        QUEM.forEach(function (k) { corpo.attributes[k] = guarda[k]; });
      }
    } else {
      /* Desmarcou: o pedido NAO pode nascer vinculado a um presenteado nem com
         recado de presente (o painel vincula por presenteado_id e le o recado da
         note, sem olhar o atributo `presente`). Limpa os tres attributes de PII
         (id, nome e o email de quem recebe) e a note - nesta loja a note E o
         recado, e a caixa de texto da /cart vive dentro do corpo que some ao
         desmarcar. Na /cart o recado continua na tela (remarcar regrava pelo
         ramo de cima) e o email, o mw-compra.js esvazia; fora dela, o recado e
         os tres atributos vao para a `guarda`. O debounce pendente morre aqui,
         senao ele reescreveria a note logo depois. */
      var a = ultimoCart && ultimoCart.attributes || {};
      var g = { note: ultimoCart && ultimoCart.note || '' }, tem = !!g.note;
      QUEM.forEach(function (k) {
        g[k] = a[k] || '';
        if (g[k]) tem = true;
        corpo.attributes[k] = '';
      });
      if (tem && !qs('[data-mw-compra]')) guarda = g;
      clearTimeout(t);
      corpo.note = '';
    }
    fetch(U_UPD, {
      method: 'POST',
      headers: JSN,
      body: JSON.stringify(corpo)
    })
      .then(rj)
      .then(atualizarHeader);
  });

  /* estado inicial: so /cart.js (badge e pontos); o drawer ja veio certo do server */
  fetch(U_CART)
    .then(rj)
    .then(atualizarHeader);
})();
